<script setup>
import { computed, ref, onMounted, getCurrentInstance, watch, useTemplateRef, onBeforeUnmount } from 'vue'
import _ from 'lodash'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { useNotification } from "@kyvg/vue3-notification"
import Spinner from "@/components/ui/Spinner.vue"
import IconBase from '@/components/icon/IconBase.vue'
import IconSettings from '@/components/icon/IconSettings.vue'
import { coloredPlatformIcon } from '@/Utils/platformIcon'

const instance = getCurrentInstance()
const root = instance.proxy.$root
const route = useRoute()
const router = useRouter()
const store = useStore()
const { notify } = useNotification()

// Props
const props = defineProps({
	platform: {
		type: Object,
		required: false,
	},
})

// Computed
const isActive = computed(() => {
	return !props.platform && store.state.Destination.isCustom || store.state.Destination.selectedPlatform && store.state.Destination.selectedPlatform?.name === props.platform?.name
})

// Methods
const selectPlatform = () => {
	store.dispatch('Destination/selectPlatform', props.platform)
	if (props.platform?.servers?.length === 1) store.dispatch('Destination/setServer', props.platform?.servers[0])
}

</script>

<template>
	<div @click="selectPlatform"
		class="w-full h-full min-h-[100px] flex flex-col items-center justify-center gap-2.5 p-3 rounded-xl cursor-pointer bg-surface-1 ring-1 ring-inset ring-white/[0.06] hover:bg-surface-3 hover:ring-white/10 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-black/30 transition-all duration-150"
		:class="{ '!bg-main-transparent !ring-main': isActive }">
		<img v-if="platform && platform.name" class="max-h-8 max-w-[80%] object-contain" :src="coloredPlatformIcon(platform)"
			:alt="platform.name" />
		<span v-else class="size-9 rounded-lg bg-surface-3 grid place-items-center text-surface-8">
			<icon-base width-view-box="24" height-view-box="24" iconColor="none" width="20" height="20">
				<icon-settings />
			</icon-base>
		</span>
		<span class="text-tiny font-medium text-white text-center truncate max-w-full">{{ platform && platform.name ?
			platform.name : 'Custom' }}</span>
	</div>
</template>